export type MediaType = "movie" | "tvshow" | "show";

export interface MediaItem {
  id: string;
  title: string;
  year: string;
  type: MediaType;
  category: string;
  region: string;
  director: string;
  actors: string[];
  rating: string;
  tags: string[];
  cover: string;
  description: string;
}

export interface NewsItem {
  id: string;
  title: string;
  summary: string;
  content: string[];
  date: string;
  author: string;
  category: string;
  cover: string;
}

export const MEDIA_TYPE_LABEL: Record<MediaType, string> = {
  movie: "电影",
  tvshow: "电视剧",
  show: "综艺",
};

export const MEDIA_TYPE_PATH: Record<MediaType, string> = {
  movie: "movie",
  tvshow: "tvshow",
  show: "show",
};